import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Container, Table, Button, Image } from 'react-bootstrap';
import logo from '../assets/logo.webp';
import { Link, useLocation } from 'react-router-dom';


export default function Orari() {


    return (
        <>
            <Helmet>
                <title>Orari - Gate 51</title>
                <meta name="description" content="" />
            </Helmet>

            <Container fluid className='py-5 ps-0 pe-0 text-center' style={{ minHeight: '100vh' }}>
                <Link to="/">
                    <Image src={logo} width={200} className='mb-5' />
                </Link>
                <Container fluid='lg' className='text-white text-center'>
                    <h1>Orari</h1>
                    <div style={{ overflowX: 'auto' }}>
                        <Table className="table small" striped bordered style={{ tableLayout: 'fixed', minWidth: 900, maxWidth: 1100, margin: 'auto' }}>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Luned&igrave;</th>
                                    <th>Marted&igrave;</th>
                                    <th>Mercoled&igrave;</th>
                                    <th>Gioved&igrave;</th>
                                    <th>Venerd&igrave;</th>
                                    <th>Sabato</th>
                                    <th>Domenica</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th>07:00</th>
                                    <td><strong>CrossFit<br /></strong>07:00 &ndash; 08:00</td>
                                    <td><strong>CrossFit<br /></strong>07:00 &ndash; 08:00</td>
                                    <td></td>
                                    <td><strong>CrossFit - Hyrox</strong><br />07:00-08:00</td>
                                    <td><strong>Crossfit</strong><br />07:00 &ndash; 08:00</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>09:00</th>
                                    <td>
                                        <p><strong>CrossFit</strong><br />09:00 &ndash; 10:00</p>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td><strong>Crossfit</strong><br />09:00 &ndash; 10:00</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>10:00</th>
                                    <td></td>
                                    <td><strong>CrossFit Senior</strong><br />10:00 &ndash; 11:00</td>
                                    <td></td>
                                    <td><strong>CrossFit Senior</strong><br />10:00 &ndash; 11:00</td>
                                    <td></td>
                                    <td><strong>Crossfit</strong><br />10:30 &ndash; 11:30</td>
                                    <td><strong>Crossfit</strong><br />10:30 &ndash; 11:30</td>
                                </tr>
                                <tr>
                                    <th>11:00</th>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td><strong>Hyrox</strong><br />11:30 &ndash; 12:30</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>12:45</th>
                                    <td><strong>CrossFit</strong><br />12:45 &ndash; 13:45</td>
                                    <td><strong>CrossFit</strong><br />12:45-13:45</td>
                                    <td><strong>CrossFit</strong><br />12:45 &ndash; 13:45</td>
                                    <td><strong>CrossFit - Hyrox</strong><br />12:45 &ndash; 13:45</td>
                                    <td><strong>Crossfit</strong><br />12:45 &ndash; 13:45</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>16:00</th>
                                    <td><strong>CrossFit Kids</strong><br />16:30 &ndash; 17:30</td>
                                    <td></td>
                                    <td><strong>CrossFit Kids</strong><br />16:30 &ndash; 17:30</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>17:00<br />21:00</th>
                                    <td><strong>CrossFit</strong><br />17:30 &ndash; 18:30<br />18:30 &ndash; 19:30<br />19:30 &ndash; 20:30<br />20:30 &ndash; 21:00<br /><strong>Weightlifting</strong><br />18:30 &ndash; 19:30</td>
                                    <td><strong>Crossfit</strong><br />17:30 &ndash; 18:30<br />18:30 &ndash; 19:30<br />19:30 &ndash; 20:30&nbsp;<br />20:30 &ndash; 21:30<br /><strong>Hyrox</strong><br />18:30 &ndash; 19:30</td>
                                    <td><strong>CrossFit</strong><br />17:00 &ndash; 18:00<br />18:00-19:00<br />19:00 &ndash; 20:00<br />20:00 &ndash; 21:00<br /><strong>Gymnastic</strong><br />19:00 &ndash; 20:00</td>
                                    <td><strong>CrossFit</strong><br />17:30 &ndash; 18:30<br />18:30 &ndash; 19:30<br />19:30 &ndash; 20:30<br />20:30 &ndash; 21:30<br /><strong>Hyrox</strong><br />19:30 &ndash; 20:30</td>
                                    <td><strong>CrossFit</strong><br />17:00 &ndash; 18:00<br />18:00-19:00<br />19:00 &ndash; 20:00<br />20:00 &ndash; 21:00<br /><strong>Hyrox</strong><br />17:00 &ndash; 18:00</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td colSpan={8}>
                                        <p>
                                            * OpenBox: LUN - MAR - GIO: 07:00 - 17:30 (17:30 - 21:30 secondo disponibilità)<br />
                                            MER - VEN: 11:00 - 17:30 (17:30 - 21:30 secondo disponibilità)<br />
                                            SAB: 10:30 - 13:00  ___ 15:00 - 18:00<br/>
                                            DOM: 14:30 - 18:00
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                </Container>
            </Container>

            <div className='text-center mt-0 mb-5'>
                <Link to="/">
                    <Button variant='outline-secondary' size='lg'>Torna alla home</Button>
                </Link>
            </div>
        </>
    );
};